export default "__VITE_ASSET__C0r2mZcw__"